// extracted by mini-css-extract-plugin
export default {"blogContainer":"Blog_blogContainer__ApXHM","gridArticles":"Blog_gridArticles__Itc4s"};